import React from 'react';
import ReactGA from 'react-ga';
import GIECard from '../../components/GIECard/GieCard';
import GIELink from "../../components/GIELink/GIELink";

export default class NotFound extends React.Component<any, any> {
    componentDidMount() {
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return (
          <div className="content">
              <div className="blue-bg-container">
                  <form className="m-auto">
                      <GIECard width="500px" height="100%">
                          <div className="p-4">
                              <h2 className="text-center mb-5">404 Erreur - Page non trouvée</h2>
                              <div className="text-center">
                                  <GIELink href="/admin/accueil" arrowBefore>Retour à l'accueil</GIELink>
                              </div>
                          </div>
                      </GIECard>
                  </form>
              </div>
          </div>
        );
    }
}
